import React, { useEffect } from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import TermsOfUseContent from './components/TermsOfUseContent'

function TermsOfUse() {
  useEffect(() => {
    document.title = 'Agência Dorac - Termos de Uso'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className='relative w-full bg-dorac-bg font-display text-dorac-ink'>
      <Header />
      <TermsOfUseContent />
      <Footer />
    </main>
  )
}

export default TermsOfUse
